export default "/react/logoSendsay-0f544400.png";